// extracted by mini-css-extract-plugin
module.exports = {"Product":"Product_Product__21EKB","Button":"Product_Button__2-NLv"};